const headerData = [{
		types: "selection",
		columnwidth: 50,
	}, {
		prop: "InvClassName",
		label: "产品线",
		columnwidth: 100
	}, {
		prop: "InvAddCode",
		label: "产品代码",
		columnwidth: 220
	},
	{
		prop: "InvName",
		label: "产品名称",
	},
	{
		prop: "UnitName",
		label: "主计量单位",
		columnwidth: 120
	},
	{
		prop: "FUnitName",
		label: "辅计量单位",
		columnwidth: 120
	},
	{
		prop: "ConvertRate",
		label: "转换率",
		columnwidth: 120
	}, {
		prop: "CreatorName",
		label: "创建人",
		columnwidth: 130
	},
	{
		prop: "CreateTime",
		label: "创建时间",
		columnwidth: 120
	}
];
export default headerData;